import {get, post} from '@/utils/http'
import {reportError} from '@/utils/util'



/**
 * 获取用户信息
 * @param deviceId
 * @returns {Promise<ResultDTO<UserInfo>>}
 */
async function getUserInfo(deviceId) {
    return await get('/user/info', {deviceId: deviceId})
}

/**
 * 注册用户
 * @param user
 * @returns {Promise<ResultDTO<>>}
 */
async function doRegister(user){
    return await post("/user/register", user);
}

async function doAdRead(deviceId){
    return await get('/user/adRead', {deviceId: deviceId});
}

export default {
    getUserInfo,doRegister,doAdRead
}
